<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <button :class="$attrs.class" class="focus:outline-none focus:ring-2 focus:ring-white" @click="open = true">
        <slot name="button"></slot>
    </button>

        <TransitionRoot as="template" :show="open">
            <Dialog as="div" static class="fixed z-50 inset-0 overflow-y-auto" @close="open = false" :open="open">
            <div class="flex flex-col items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 bg-dark relative w-full">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="transform transition-all text-white w-full flex flex-col items-center justify-center">
                      <button
                          class="absolute top-0 right-0 p-4 text-white mt-5"
                          type="button"
                          @click="open = false"
                      >
                          <XCircleIcon class="w-6 h-6"></XCircleIcon>
                      </button>
                      <slot></slot>
                    </div>
                </TransitionChild>
            </div>
            </Dialog>
        </TransitionRoot>
</template>

<script>
import { ref } from 'vue'
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XCircleIcon } from '@heroicons/vue/outline'

export default {
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    XCircleIcon,
  },

  props: {
  },

  setup( props ) {
    const open = ref(false)

    return {
      open
    }
  },
}
</script>
